import script from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertMessage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__